export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/JO-f344691625451dc007c5b85f1052a827.png";